import React, { FunctionComponent } from "react";
import { FormattedNumber, useIntl } from "react-intl";
import useCartContext from "@Hooks/useCartContext";
import { PriceFormatted } from "@Types/price";
import "./style.scss";

export interface OrderContentArticles {
  name: string;
  quantity: number;
  total: PriceFormatted;
}

interface Props {
  articles: OrderContentArticles[];
  subTotal?: PriceFormatted;
}

export const CartOrderContent: FunctionComponent<Props> = ({ articles, subTotal }) => {
  const intl = useIntl();

  return (
    <ul className="CartOrderContent">
      {articles.map(({ name, quantity, total }, index) => (
        <li className="CartOrderContent-line" key={index}>
          <span className="CartOrderContent-line-label">
            {quantity} x {name}
          </span>
          <FormattedNumber value={total.cents / 100} style="currency" currency={total.currency} />
        </li>
      ))}
      {subTotal && (
        <li className="CartOrderContent-line">
          <span className="CartOrderContent-line-label CartOrderContent-line-subTotal">
            {intl.formatMessage({
              id: "cheerz_CartOverviewTile_subTotal",
            })}
          </span>
          <FormattedNumber
            value={subTotal.cents / 100}
            style="currency"
            currency={subTotal.currency}
          />
        </li>
      )}
    </ul>
  );
};

const CartOrderContentContainer: FunctionComponent = () => {
  const { cart } = useCartContext();
  const articles = cart.articles.map((article) => {
    return {
      name: article.product.name,
      quantity: article.quantity,
      total: article.total,
    };
  });

  return <CartOrderContent articles={articles} subTotal={cart.subTotal} />;
};

export default CartOrderContentContainer;
